export enum ScheduleType {
    Day = 'Day',
    Month = 'Month',
    Year = 'Year',
}

export enum ScheduleDayType {
    EveryDay = 'EveryDay',
    EveryDaysOfMonth = 'EveryDaysOfMonth',
    SpecificDayOfWeek = 'SpecificDayOfWeek',
    SpecificDayOfMonth = 'SpecificDayOfMonth',
    LastDayOfMonth = 'LastDayOfMonth',
    LastWeekdayOfMonth = 'LastWeekdayOfMonth',
    LastDayOfWeekOfMonth = 'LastDayOfWeekOfMonth',
    LastNDaysBeforeMonthEnd = 'LastNDaysBeforeMonthEnd',
    NearestWeekdayToDay = 'NearestWeekdayToDay',
    DayAndWeekdayOfMonth = 'DayAndWeekdayOfMonth',
}

export enum ScheduleMonthType {
    EveryMonth = 'EveryMonth',
    EveryMonthsStartingIn = 'EveryMonthsStartingIn',
    SpecificMonth = 'SpecificMonth',
    EveryMonthBetween = 'EveryMonthBetween',
}

export enum ScheduleYearType {
    EveryYear = 'EveryYear',
    EveryYearsStartingIn = 'EveryYearsStartingIn',
    SpecificYear = 'SpecificYear',
    EveryYearBetween = 'EveryYearBetween',
}

export const schedulerFormNames = {
    tab: 'tab',
    time: 'time',
    endDate: 'endDate',
    specificDayOfMonth: 'specificDayOfMonth',
    specificMonth: 'specificMonth',
    yearBetweenStart: 'yearBetweenStart',
    yearBetweenEnd: 'yearBetweenEnd',
    nthDayOfWeek: 'nthDayOfWeek',
    startingFromOfWeek: 'startingFromOfWeek',
    startingDayOfMonth: 'startingDayOfMonth',
    nthDayOfMonth: 'nthDayOfMonth',
    weekday: 'weekday',
    dayOption: 'dayOption',
    monthOption: 'monthOption',
    yearOption: 'yearOption',
    monthPeriod: 'monthPeriod',
    startMonth: 'startMonth',
    monthBetweenStart: 'monthBetweenStart',
    monthBetweenEnd: 'monthBetweenEnd',
    yearPeriod: 'yearPeriod',
    startYear: 'startYear',
    specificYear: 'specificYear',
    specificYearStart: 'specificYearStart',
    specificYearEnd: 'specificYearEnd',
    specificYearExcluded: 'specificYearExcluded',
    lastDayOfWeekOfMonth: 'lastDayOfWeekOfMonth',
    lastNDaysBeforeMonthEnd: 'lastNDaysBeforeMonthEnd',
    nearestWeekdayToDay: 'nearestWeekdayToDay',
    nthDayOfWeekMonth: 'nthDayOfWeekMonth',
    dayOfWeekOfMonth: 'dayOfWeekOfMonth',
} as const;

export const yearsItems = Array.from({ length: 10 }, (_, i) => ({
    id: new Date().getFullYear() + i,
    name: (new Date().getFullYear() + i).toString(),
}));

export const yearsNumberItems = Array.from({ length: 10 }, (_, i) => ({
    id: i + 1,
    name: (i + 1).toString(),
}));
